var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChat = function SvgChat(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27547 11.5214C1.27547 6.06514 6.13549 1.75 11.9756 1.75C17.813 1.75 22.7231 6.07217 22.7231 11.5499C22.7231 17.0232 17.8652 21.3498 12.023 21.3498L12.0212 21.3497C11.0913 21.3475 10.1654 21.2329 9.2635 21.0086L3.11997 22.2355C2.8741 22.2846 2.61996 22.2076 2.44269 22.0303C2.26543 21.8529 2.18849 21.5988 2.23766 21.3529L3.11805 16.951C1.95003 15.3865 1.30339 13.4904 1.27554 11.5321L1.27539 11.5214H1.27547ZM2.77547 11.5161C2.80141 13.256 3.40999 14.937 4.50399 16.2903C4.64411 16.4637 4.69988 16.6904 4.65616 16.9089L3.92909 20.5443L9.13744 19.5042C9.24976 19.4817 9.36572 19.4853 9.47644 19.5147C10.3078 19.735 11.164 19.8476 12.024 19.8498C17.1738 19.8492 21.2231 16.0643 21.2231 11.5499C21.2231 7.03955 17.1307 3.25 11.9756 3.25C6.82521 3.25 2.77867 7.02464 2.77547 11.5161Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chat.e70906fec7a4d0d2d662698fc3e88c4d.svg";